import { useQuery } from "@tanstack/react-query";
import type { TGetAnnouncementPopupResponse, TGetAnnouncementResponse } from "../types/announcement";
import { keyFactory } from "../util/keyFactory";
import { HttpClient } from "./axiosConfig";

export const useGetAnnouncement = (announcementTypes: number | Array<number>) => {
  return useQuery({
    queryKey: [keyFactory.getAnnouncement, announcementTypes],
    queryFn: async () => {
      const types = Array.isArray(announcementTypes) ? announcementTypes : [announcementTypes];

      const parameters = new URLSearchParams();
      types.forEach(type => {
        parameters.append('announcementType', type.toString());
      });

      const result = await HttpClient.get<TGetAnnouncementResponse>(
        `/users/announcements?${parameters.toString()}`
      );
      return result.data;
    }
  });
};

export const useGetAnnouncementPopups = (
  popupAlertTypes: string | Array<string>,
  enabled: boolean
) => {
  return useQuery({
    queryKey: [keyFactory.getAnnouncementPopups, popupAlertTypes],
    enabled,
    queryFn: async () => {
      const types = Array.isArray(popupAlertTypes) ? popupAlertTypes : [popupAlertTypes];

      const parameters = new URLSearchParams();
      types.forEach((type) => {
        parameters.append("popupAlertType", type);
      });

      const result = await HttpClient.get<TGetAnnouncementPopupResponse>(
        `/users/announcements/popups?${parameters.toString()}`
      );
      return result.data;
    },
  });
};

/** Response shape matching CF closeAnnouncementPopup (isError 0 = success, -1 = session expired, 1 = error) */
export interface CloseAnnouncementPopupResponse {
  isError?: number;
  ISERROR?: number;
  errMsg?: string;
}

export const closeAnnouncementPopup = async (
  eventAnnouncementId: string,
  donotShowAgainValue: number
): Promise<CloseAnnouncementPopupResponse> => {
  const parameters = new URLSearchParams();
  parameters.append("eAnnouncementId", eventAnnouncementId);
  parameters.append("donotShowAgainVal", donotShowAgainValue.toString());

  const response = await HttpClient.put<CloseAnnouncementPopupResponse>(
    `/users/announcements/popups/close?${parameters.toString()}`
  );
  return response.data ?? {};
};
